import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import React from 'react';
import { pxToRem } from 'src/common/utils/fonts';

type ErrorOverflowBoxProps = {
  children?: React.ReactNode;
};

export const ErrorOverflowBox = ({ children }: ErrorOverflowBoxProps) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,

        bottom: pxToRem(34),
        background: (theme) => alpha(theme.palette.background.default, 0.8),
      }}
    >
      {children}
    </Box>
  );
};
